import App from "./App.vue";

frappe.provide("appl_detail");

class ApplDetail {
	constructor(element, doc, is_new) {
		if (!is_new) {
			is_new = false;
		} else {
			is_new = true;
		}

		if (!doc.application_details) {
			doc.application_details = new Array();
		}

		this.app = new Vue({
			el: element,
			render(h) {
				return h(
					App, {
					props: { doc, is_new },
				});
			},
		});
	}
}

appl_detail["ApplDetail"] = ApplDetail;
appl_detail["App"] = App;